import { render, staticRenderFns } from "./CategoryIn.vue?vue&type=template&id=0fd3acae&scoped=true&"
import script from "./CategoryIn.vue?vue&type=script&lang=js&"
export * from "./CategoryIn.vue?vue&type=script&lang=js&"
import style0 from "./CategoryIn.vue?vue&type=style&index=0&id=0fd3acae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd3acae",
  null
  
)

export default component.exports